module.exports = __webpack_public_path__ + "img/app-group-fill.9183e7ea.svg";